import React from 'react';
import PropTypes from 'prop-types';

import { WHITE, IRON, DODGER_BLUE } from '@constant/colors';

const MailContent = ({ className }) => {
  return (
    <svg className={className} viewBox="0 0 180 133">
      <g fill="none" fillRule="evenodd">
        <path fill={WHITE} d="M0 0h179.3493v133H0z" />
        <path
          d="M28.91 109.553a1.067 1.067 0 0 1 1.0725-1.0688h115.6368c.5923 0 1.0724.4744 1.0724 1.0688a1.067 1.067 0 0 1-1.0724 1.0688H29.9825c-.5923 0-1.0724-.4744-1.0724-1.0688zm0 6.4129c0-.5903.4707-1.0688 1.0646-1.0688h121.0063c.588 0 1.0645.4744 1.0645 1.0688 0 .5903-.4707 1.0688-1.0645 1.0688H29.9746c-.588 0-1.0645-.4744-1.0645-1.0688zm0 6.4128c0-.5903.4814-1.0688 1.069-1.0688h111.3608c.5903 0 1.069.4744 1.069 1.0688 0 .5903-.4814 1.0688-1.069 1.0688H29.979a1.0663 1.0663 0 0 1-1.069-1.0688z"
          fill={IRON}
          opacity=".5"
        />
        <rect
          fill={DODGER_BLUE}
          x="54.0725"
          y="80.6951"
          width="70.669"
          height="12.2913"
          rx="6.1457"
        />
      </g>
    </svg>
  );
};

MailContent.propTypes = {
  className: PropTypes.string,
};

export default MailContent;
